"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOfferItemsHandler = updateOfferItemsHandler;
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
async function updateOfferItemsHandler({
  detail: {
    choiceId,
    items,
    placement
  }
}) {
  const response = await fetch(_types.RequestUrl.UpdateOfferItems, (0, _utils.getHttpRequestSettings)({
    choiceId,
    items,
    placement
  }, _checkoutUtils.HttpMethod.Post));
  return (0, _utils.convertToCamelCase)(await response.json());
}